module.exports = "/_next/static/images/favicon-32x32-5315f672697fc6d275e1f630f70c785a.png";